import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';

import { ErrorText } from './elements';

import { useText } from 'common/hooks';

const deps = {
  authenticationError: state.appContainer.auth.authenticationError,
};

function AuthenticationError({
  authenticationError,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();

  if (authenticationError) {
    return (
      <ErrorText>
        {t('authentication.error', {
          errorMessage: t(authenticationError.message),
        })}
      </ErrorText>
    );
  }

  return null;
}

export default connect(deps, AuthenticationError);
